import { render, staticRenderFns } from "./LanguageSwitcherNav.vue?vue&type=template&id=eed220f0&scoped=true&"
import script from "./LanguageSwitcherNav.vue?vue&type=script&lang=js&"
export * from "./LanguageSwitcherNav.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSwitcherNav.vue?vue&type=style&index=0&id=eed220f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed220f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eed220f0')) {
      api.createRecord('eed220f0', component.options)
    } else {
      api.reload('eed220f0', component.options)
    }
    module.hot.accept("./LanguageSwitcherNav.vue?vue&type=template&id=eed220f0&scoped=true&", function () {
      api.rerender('eed220f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Includes/LanguageSwitcherNav.vue"
export default component.exports